import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
class SendMessage extends Component {

    constructor(props) {
        super(props);

    }

    handleSubmit(evt) {
    }

    handlePress(evt) {

    }
    handleChange(evt) {

    }



    render() {
        let dis = "none";
        let avatar = "/imgs/spacer.gif";
        let city = "";
        if(this.props.Profile.Image.Url) {
            avatar = this.props.Profile.Image.Url;
        }
        if(this.props.Profile.Location && this.props.Profile.Location.City) {
            city = this.props.Profile.Location.City.Name;
        }
        if(this.props.Profile.ShowingSendMessageProfile) { dis="inline-block"; }
        return (
            <div id="send-message-popup" className="popup-wrapper flex" style={{display: dis, maxWidth: '700px'}}>
                <div className="regular-content">
                  <div className="centered-content">
                      <h3>Send {this.props.Profile.MessageType} Message</h3>
                      <h5>You are sending a message to:</h5>
                  </div>
                  <div className="model-message">
                    <a href="javascript:;" title="" className="avatar"><img src={avatar} alt={this.props.Profile.Name} width={"100"} style={{borderRadius: "8px"}} /></a>
                    <div className="text-content">
                      <h4>{this.props.Profile.Name}</h4>
                      {city !== "" && <span className="location"><i className="fas fa-map-marker-alt"></i>  {city}</span>}
                    </div>
                  </div>
                  {this.props.Profile.MessageType === "SMS" &&
                    <div className="input-block">
                      <label>Your phone</label>
                      <input type={"text"} placeholder="+00 000 0000" style={{resize: 'none'}}/>
                    </div>
                  }
                  {this.props.Profile.MessageType === "EMAIL" &&
                  <div className="input-block">
                    <label>Your email</label>
                    <input type={"text"} placeholder="email@domain.com" style={{resize: 'none'}}/>
                  </div>
                  }

                  <div className="input-block">
                     <label>Your message</label>
                     <textarea placeholder="Write message" style={{resize: 'none'}}></textarea>
                  </div>
                  <input type="submit" className="button full" value="Send Message" name=""/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        WebPage: state.Website,
        Profile: state.Website.SendMessageProfile
    };
}

export default connect(mapStateToProps)(SendMessage);
